<template>
  <section data-testid="about-redemption">
    <div v-if="isLoading" class="loader">
      <SpinnerLoader :size="48" />
    </div>
    <div v-else-if="hasError" class="helper-view">
      <HelperViewStatus
        button-label="Tentar novamente"
        generic-error
        @click="handleHelperClick"
      />
    </div>
    <div v-else class="redemption">
      <HeadingDisplay
        size="medium"
        title="Prazo total de resgate"
        subtitle="Sua carteira tem produtos com diferentes prazos de resgate. Para não impactar a performance, os resgates são feitos de forma balanceada, conforme a proporção dos produtos."
      />

      <div class="redemption__list">
        <div
          v-for="redemption in redemptionProducts"
          :key="redemption.redemptionDay"
          class="redemption__list__item"
        >
          <BaseText size="p3" class="redemption__list__item--date">{{
            redemption.redemptionDay
          }}</BaseText>

          <div
            v-for="product in redemption.products"
            :key="product.name"
            class="redemption__list__item--name"
          >
            <BaseText size="p3">{{ product.name }}</BaseText>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import {
  getPreviewRedemptionProducts,
  IPreviewRedemptionProducts
} from '@/modules/wealth/services/wealth-about';
import {
  BaseText,
  HeadingDisplay,
  HelperViewStatus,
  SpinnerLoader
} from '@warrenbrasil/nebraska-web';
import { onMounted, ref } from 'vue';

const isLoading = ref(true);
const hasError = ref(false);
const redemptionProducts = ref<IPreviewRedemptionProducts[]>();

const props = defineProps<{ portfolioId: string }>();

async function fetchPreviewRedemptionProducts() {
  isLoading.value = true;
  hasError.value = false;

  try {
    const response = await getPreviewRedemptionProducts(props.portfolioId);
    redemptionProducts.value = response;
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

const handleHelperClick = () => {
  fetchPreviewRedemptionProducts();
};

onMounted(() => {
  fetchPreviewRedemptionProducts();
});
</script>

<style lang="less" scoped>
.helper-view {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: @size-spacing-x1000 0;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: @size-spacing-x1200 0;
}

.redemption {
  margin-bottom: @size-spacing-x1000;

  &__list {
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x600;
    padding-top: @size-spacing-x600;

    &__item {
      &:not(:last-child) {
        border-bottom: @size-border-x400 solid @divider-primary;
      }

      &--date {
        padding-bottom: @size-spacing-x400;
      }

      &--name {
        padding-bottom: @size-spacing-x450;

        :deep(.base-text) {
          color: @element-primary !important;
        }
      }
    }
  }
}
</style>
